import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@paygreen/paygreen-ui';

const DashboardCardSkeleton = ({ lineNumber, blockWidth, ...rest }) => (
    <Skeleton
        blockWidth={blockWidth}
        lineNumber={lineNumber}
        shadowSize="none"
        hasResponsivePadding={true}
        padding="md"
        radiusSize="sm"
        {...rest}
    />
);

DashboardCardSkeleton.propTypes = {
    lineNumber: PropTypes.number,
    blockWidth: PropTypes.string,
};

DashboardCardSkeleton.defaultProps = {
    blockWidth: 'none',
    lineNumber: 1,
};

export default DashboardCardSkeleton;
